"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GracePeriodDtoTypeEnum = void 0;
exports.instanceOfGracePeriodDto = instanceOfGracePeriodDto;
exports.GracePeriodDtoFromJSON = GracePeriodDtoFromJSON;
exports.GracePeriodDtoFromJSONTyped = GracePeriodDtoFromJSONTyped;
exports.GracePeriodDtoToJSON = GracePeriodDtoToJSON;
exports.GracePeriodDtoToJSONTyped = GracePeriodDtoToJSONTyped;
/**
 * @export
 */
exports.GracePeriodDtoTypeEnum = {
    FreeTrial: 'free_trial'
};
/**
 * Check if a given object implements the GracePeriodDto interface.
 */
function instanceOfGracePeriodDto(value) {
    if (!('active' in value) || value['active'] === undefined)
        return false;
    if (!('endsAt' in value) || value['endsAt'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function GracePeriodDtoFromJSON(json) {
    return GracePeriodDtoFromJSONTyped(json, false);
}
function GracePeriodDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'active': json['active'],
        'endsAt': json['endsAt'],
        'type': json['type'],
    };
}
function GracePeriodDtoToJSON(json) {
    return GracePeriodDtoToJSONTyped(json, false);
}
function GracePeriodDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'active': value['active'],
        'endsAt': value['endsAt'],
        'type': value['type'],
    };
}
